module.exports = __WEBPACK_EXTERNAL_MODULE_11__;


//////////////////
// WEBPACK FOOTER
// external "ecCom"
// module id = 11
// module chunks = 6 7